import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/es.string.includes.js';
import 'core-js/modules/es.object.assign.js';
import { __awaiter } from '../../../../_virtual/_tslib.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { styled, Stack, shape, palette, spacing, useIsMobile, Text } from '@hub-la/design-system';
import { UploadStatus, UploadAssetBySignedUrl } from '@hub-la/fe-asset';
import CloseIcon from '@mui/icons-material/Close';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { memo, useState, useEffect } from 'react';
import { useQueryClient } from 'react-query';
import '../../../domain/dtos/alert-type.js';
import '../../../domain/dtos/error-type.js';
import '../../../domain/dtos/main-content-type.js';
import '../../../domain/dtos/post-event-type.js';
import '../../../domain/dtos/post-status.js';
import { QueryKey } from '../../../domain/dtos/query-key.js';
import '../../../domain/dtos/remove-dialog-action.js';
import { useVideoStatus } from '../../hooks/use-video-status.js';
import { useVideosUploader } from '../../hooks/use-videos-uploader.js';
import { EmptyState } from './empty-state.js';
import { Item } from './item.js';

let _ = t => t,
  _t,
  _t2;
const Card = styled(Stack)(_t || (_t = _`
  border-radius: ${0} ${0} 0 0;
  border: 1px solid ${0};
  position: fixed;
  bottom: 0;
  z-index: 20;
  background-color: ${0};
`), shape('small'), shape('small'), palette('surfaceVariant'), palette('surface'));
const Header = styled(Stack)(_t2 || (_t2 = _`
  border-bottom: 1px solid ${0};
  height: 48px;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  padding: 0 ${0};
`), palette('surfaceVariant'), spacing(6));
const VideosUploader = /*#__PURE__*/memo(() => {
  const isMobile = useIsMobile();
  const queryClient = useQueryClient();
  const {
    videos
  } = useVideosUploader();
  const {
    getStatus,
    updateStatus
  } = useVideoStatus(videos);
  const hasVideos = videos.length;
  const [expanded, setExpanded] = useState(true);
  const [showCard, setShowCard] = useState(!!hasVideos);
  const [uploading, setUploading] = useState({
    progress: 0,
    name: ''
  });
  const countVideosByStatus = status => {
    return videos.filter(video => status.includes(getStatus(video.file.name))).length;
  };
  const countSuccessful = countVideosByStatus(UploadStatus.SUCCESS);
  const countFailed = countVideosByStatus(UploadStatus.ERROR);
  const toggle = () => setExpanded(expanded => !expanded);
  const closed = () => setShowCard(opened => !opened);
  const upload = video => __awaiter(void 0, void 0, void 0, function* () {
    updateStatus(video.file.name, UploadStatus.PROCESSING);
    yield new UploadAssetBySignedUrl().execute({
      onUploadProgress: progress => {
        setUploading({
          progress,
          name: video.file.name
        });
      },
      writeUrl: video.writeUrl,
      file: video.file,
      mimeType: video.file.type,
      asset: video.asset
    });
    updateStatus(video.file.name, UploadStatus.SUCCESS);
    yield queryClient.refetchQueries(QueryKey.listSections);
  });
  const getTitle = () => {
    const empty = 'Nenhum arquivo sendo enviado';
    if (!videos.length) {
      return empty;
    }
    const successfully = 'Upload concluído!';
    const title = videos.length === countSuccessful ? successfully : countFailed ? `${countSuccessful} vídeos enviados e ${countFailed} falharam...` : `Enviando ${countSuccessful + 1}/${videos.length} arquivos...`;
    return title || empty;
  };
  useEffect(() => {
    // it prevents the user from leaving the page while the videos are being uploaded
    window.onbeforeunload = hasVideos === countSuccessful ? null : () => true;
  }, [hasVideos, countSuccessful]);
  useEffect(() => {
    (function () {
      return __awaiter(this, void 0, void 0, function* () {
        if (!hasVideos) return;
        setShowCard(true);
        for (const video of videos) {
          const status = getStatus(video.file.name);
          if (status === UploadStatus.NO_CALLED) {
            yield upload(video);
          }
        }
      });
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [videos]);
  return showCard ? jsxs(Card, Object.assign({
    "data-testid": "videos-uploader",
    width: isMobile ? '100%' : '360px',
    left: isMobile ? 0 : '48px'
  }, {
    children: [jsxs(Header, {
      children: [jsx(Text, Object.assign({
        variant: "body1",
        color: "onSurface"
      }, {
        children: getTitle()
      })), jsxs(Stack, Object.assign({
        flexDirection: "row"
      }, {
        children: [expanded ? jsx(ExpandMoreIcon, {
          onClick: toggle,
          sx: {
            cursor: 'pointer'
          }
        }) : jsx(ExpandLessIcon, {
          onClick: toggle,
          sx: {
            cursor: 'pointer'
          }
        }), hasVideos === countSuccessful && jsx(CloseIcon, {
          onClick: closed,
          sx: {
            marginLeft: spacing(3),
            cursor: 'pointer'
          }
        })]
      }))]
    }), expanded && jsx(Stack, Object.assign({
      flexDirection: "column",
      overflow: "scroll",
      maxHeight: "250px"
    }, {
      children: hasVideos ? videos.map(video => jsx(Item, {
        status: getStatus(video.file.name),
        name: video.file.name,
        progress: uploading.name === video.file.name ? uploading.progress : 0
      }, video.file.name)) : jsx(EmptyState, {})
    }))]
  })) : null;
});

export { VideosUploader };
